import { render, staticRenderFns } from "./CreateRateCard2.vue?vue&type=template&id=7019631f&"
import script from "./CreateRateCard2.vue?vue&type=script&lang=js&"
export * from "./CreateRateCard2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports